import * as React from "react";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { ListItem } from "../../list/list-item/list-item.mjs";
import { ArrowListContext } from "../arrow-list/arrow-list.mjs";
const ArrowListItem = React.forwardRef(function ArrowListItem2(props, ref) {
  var _a;
  const context = React.useContext(ArrowListContext);
  const color = (_a = props.color) != null ? _a : context.purpose;
  const theme = context.theme;
  const large = context.large;
  const hover = context.backgroundHover;
  const { showArrow = true, icon, iconClassName: iconClassNameProp, isActive, ...rest } = props;
  const iconClassName = iconClassNameProp != null ? iconClassNameProp : context.iconClassName;
  const listItemBem = () => {
    const classArray = ["arrow-list__item ".concat(large && getHeaderBackgroundColor())];
    if (props.className) {
      classArray.push(props.className);
    }
    if (hover && !props.isActive && props.url) {
      classArray.push("arrow-list__item--hover");
    }
    if (props.isActive) {
      classArray.push("arrow-list__item--active");
    }
    if (color) {
      classArray.push("arrow-list__item--".concat(color));
    }
    return classArray.join(" ");
  };
  const iconBEM = () => {
    const classArray = ["arrow-list__icon"];
    if (iconClassName) {
      classArray.push(iconClassName);
    }
    return classArray.join(" ");
  };
  const getHeaderBackgroundColor = () => {
    if (props.isActive) {
      return "bg-neutral-bg-level-1";
    }
    switch (context.backgroundColor) {
      case "beige":
        return "bg-brand-secondary-bg-subtlest";
      case "white":
        return "bg-neutral-bg-level-1";
      default:
        return "bg-neutral-bg-level-2";
    }
  };
  const ArrowListContent = () => {
    return /* @__PURE__ */ React.createElement("div", { className: "arrow-list__content" }, /* @__PURE__ */ React.createElement("div", { className: "arrow-list__inner" }, props.children), showArrow && /* @__PURE__ */ React.createElement(Icon, { size: large ? "sm" : "xs", modifiers: "#arrow-right", className: "arrow-list__arrow-icon" }));
  };
  return /* @__PURE__ */ React.createElement(ListItem, { className: listItemBem(), icon, iconClassName: iconBEM() }, /* @__PURE__ */ React.createElement(
    Anchor,
    {
      isUnderlined: false,
      ...rest,
      isTextColor: !color,
      color,
      className: "arrow-list__link",
      theme: !color ? theme : void 0,
      url: props.url,
      ref
    },
    /* @__PURE__ */ React.createElement(ArrowListContent, null)
  ));
});
export {
  ArrowListItem
};
